import React from 'react';

import {
  StorageOfUniqueServices,
  TestCyclesService,
} from '@qality/common-service';
import { Utils } from '@qality/common-utils';

import { RecentTestCyclesContext } from './RecentTestCyclesContext';

export interface RecentTestCyclesProviderProps {
  projectIds: string;
  children: React.ReactNode;
}

export const RecentTestCyclesProvider: React.FC<RecentTestCyclesProviderProps> =
  ({ projectIds, children }: RecentTestCyclesProviderProps) => {
    const [testCycles, setTestCycles] = React.useState([]);
    const [selectedTestCycle, setSelectedTestCycle] = React.useState(null);
    const [isTableView, seIsTableView] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);
    React.useEffect(() => {
      const init = async () => {
        setIsLoading(true);
        const response = await TestCyclesService.fetchTestCycles(0, {
          ...(projectIds ? { projectIds } : null),
          includeStatuses: true,
        });
        setTestCycles(response.testCycles.slice(0, 5));
        setSelectedTestCycle(
          response.testCycles.length !== 0 ? response.testCycles[0] : null
        );
        seIsTableView(false);
        setIsLoading(false);
      };

      StorageOfUniqueServices.get('AP').events.on(
        'event_testCycle-created',
        () => init()
      );

      init();
    }, []);

    const handleOverviewAction = (testCycleId: string | number) => {
      const found = testCycles.find(
        (testCycle) => testCycle.id === testCycleId
      );
      setSelectedTestCycle(!Utils.isNilOrEmpty(found) ? found : testCycles[0]);
      seIsTableView(false);
    };

    return (
      <RecentTestCyclesContext.Provider
        value={{
          testCycles,
          selectedTestCycle,
          isTableView,
          isLoading,
          isProjectContext: !Utils.isNilOrEmpty(projectIds),
          handleViewMore: () => seIsTableView(true),
          handleOverviewAction: handleOverviewAction,
        }}
      >
        {children}
      </RecentTestCyclesContext.Provider>
    );
  };
